import { cva, type VariantProps } from "class-variance-authority";
import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

const sliderVariants = cva("accent-healing-500 cursor-pointer", {
  variants: {
    size: {
      default: "flex-1",
      compact: "w-14 shrink-0",
      wide: "w-16 h-2 shrink-0",
    },
  },
  defaultVariants: {
    size: "default",
  },
});

export interface SliderProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "size">,
    VariantProps<typeof sliderVariants> {}

export const Slider = forwardRef<HTMLInputElement, SliderProps>(
  ({ className, size, ...props }, ref) => (
    <input
      type="range"
      className={cn(sliderVariants({ size }), className)}
      ref={ref}
      {...props}
    />
  ),
);
Slider.displayName = "Slider";

export { sliderVariants };
